var _defs, _rect, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.557 2.023 62.887 62.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a5a5a"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 27,
    width: 46.5,
    height: 25,
    fill: "url(#cb)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#151515"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 27,
    width: 4.5,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 27,
    width: 4.5,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 27,
    width: 4.5,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 27,
    width: 4.5,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 27,
    width: 4.5,
    height: 25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#151515"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 22 L32 6 L59 22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 22,
    width: 54,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 51,
    width: 54,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 55,
    width: 60,
    height: 6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20 L32 10 L50 20Z",
    fill: "#4a4a4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.be789778a32a5998dd19b4097e805e51.svg";
export { ForwardRef as ReactComponent };